import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import {
  SET_ACTION_CONFIRMATION_CANCEL,
  SET_ACTION_CONFIRMATION_DIALOG,
  SET_ACTION_CONFIRMATION_FUNCTION,
} from "../../store/actionTypes/globalActionType";
import parser from "html-react-parser";

export const openActionDialog = (dispatch, action, cancel = null) => {
  dispatch({ type: SET_ACTION_CONFIRMATION_DIALOG, payload: true });
  dispatch({ type: SET_ACTION_CONFIRMATION_FUNCTION, payload: action });
  if (cancel) {
    dispatch({ type: SET_ACTION_CONFIRMATION_CANCEL, payload: cancel });
  }
};

export const ActionConfirmationDialog = () => {
  const dispatch = useDispatch();
  const { actionDialogOpen, actionDialogFunction, actionDialogCancel } =
    useSelector((state) => state.global);

  const { t: tCommon } = useTranslation();

  const cleanFunction = () => {
    dispatch({ type: SET_ACTION_CONFIRMATION_DIALOG, payload: false });
    dispatch({ type: SET_ACTION_CONFIRMATION_FUNCTION, payload: null });
    dispatch({ type: SET_ACTION_CONFIRMATION_CANCEL, payload: null });
  };

  const handleAction = () => {
    if (actionDialogFunction) actionDialogFunction();
    cleanFunction();
  };

  const handleCancel = () => {
    if (actionDialogCancel) actionDialogCancel();
    cleanFunction();
  };

  return (
    <>
      <Dialog maxWidth="sm" open={actionDialogOpen}>
        <DialogContent>
          <DialogContentText
            sx={{
              mb: 2,
              textAlign: "center",
            }}
          >
            {parser(tCommon("actionConfirmationText"))}
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button variant="outlined" fullWidth onClick={handleCancel}>
            {tCommon("noBtn")}
          </Button>

          <Button variant="contained" fullWidth onClick={handleAction}>
            {tCommon("yesBtn")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
